import React, { FC } from 'react';

import Block, { TextSize } from '../Block';
import Text, { FontWeight } from '../Text';

import { HeadingProps, HeadingSize } from './Heading.types';

const textSizes: Record<HeadingSize, TextSize> = {
  1: TextSize.Large,
  2: TextSize.Large,
  3: TextSize.Large,
  4: TextSize.Large,
  5: TextSize.Medium,
  6: TextSize.MediumSub,
};

const fontWeights: Record<HeadingSize, FontWeight> = {
  1: FontWeight.Bold,
  2: FontWeight.Bold,
  3: FontWeight.Bold,
  4: FontWeight.SemiBold,
  5: FontWeight.Regular,
  6: FontWeight.Regular,
};

/**
 * A `Heading` component renders text at different size/weight depending on the given level.
 *
 * Note that semantic heading level (H1...H6) as used by screenreader navigation is expressed
 * using the separate SemanticHeading component.
 */

const Heading: FC<HeadingProps> = (props) => {
  const { size, children } = props;

  const textSize = textSizes[size];
  const fontWeight = fontWeights[size];

  return (
    <Block textSize={textSize}>
      <Text fontWeight={fontWeight}>{children}</Text>
    </Block>
  );
};

export default Heading;
